export class FixedStepper {
  private accumulator = 0;

  constructor(readonly dt = 1 / 240, readonly maxSteps = 8) {}

  /** Runs whole fixed steps for the elapsed frame time; returns the render interpolation alpha. */
  advance(frameSeconds: number, step: (dt: number) => void): number {
    this.accumulator += frameSeconds;
    let steps = 0;
    while (this.accumulator >= this.dt && steps < this.maxSteps) {
      step(this.dt);
      this.accumulator -= this.dt;
      steps++;
    }
    if (steps === this.maxSteps && this.accumulator >= this.dt) this.accumulator = 0;
    return this.accumulator / this.dt;
  }
}
